import { RefObject } from 'react';

export const focusOn = (
  ref: RefObject<HTMLElement | null>,
  retries = 0,
): void => {
  if (ref.current) {
    ref.current.focus();
  } else if (retries < 10) {
    window.setTimeout(() => focusOn(ref, retries + 1), 50);
  }
};

type LegacyInputElement = HTMLInputElement & {
  createTextRange?: () => {
    move: (unit: string, count: number) => void;
    select: () => void;
  };
};

export const updateCaretPosition = (
  element: LegacyInputElement | null,
  caretPos: number,
): void => {
  if (element != null) {
    if (element.createTextRange) {
      const range = element.createTextRange();

      range.move('character', caretPos);
      range.select();
    } else if (element.selectionStart) {
      element.focus();
      element.setSelectionRange(caretPos, caretPos);
    } else {
      element.focus();
    }
  }
};
